var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BRow, BCol, BFormGroup, BFormRadioGroup, BFormInput, BButton, BCard, BOverlay, BAlert } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
import { DiscountsBreakdown } from '@vallaton-limited/vue-components';
import UpsellUnitProduct from 'components/UpsellUnitProduct.vue';
import ProductDiscontinued from 'components/materials/ProductDiscontinued.vue';
import { addToCart } from 'ts/modules/cart';
import { checkUnitStock } from 'ts/modules/stock';
import { getProductDiscounts, getUnitPrice } from 'ts/modules/pricing';
import { getVatMode, isAdmin } from 'ts/modules/helpers';
let Unit = class Unit extends Vue {
    constructor() {
        super(...arguments);
        this.product = null;
        this.loading = true;
        this.loadingDiscounts = true;
        this.loadingPrice = true;
        this.loadingStock = true;
        this.isAddingToCart = false;
        this.vatMode = 'inc';
        this.isAdmin = false;
        this.isInStock = true;
        this.quantity = 1;
        this.packSize = null;
        this.packSizeOptions = [];
        this.discounts = [];
        this.pricing = {
            base_unit_price: '0.00',
            ex_vat_base_unit_price: '0.00',
            unit_price: '0.00',
            total_price: '0.00',
            unit_discount: '0.00',
            total_discount: '0.00'
        };
        this.debouncedUpdate = debounce(this.update, 250);
    }
    get isValidQuantity() {
        return this.quantity > 0;
    }
    get isAddToCartDisabled() {
        return (!this.isInStock && !this.isAdmin)
            || !this.isValidQuantity
            || this.isAddingToCart;
    }
    get buyButtonVariant() {
        return !this.isInStock || !this.isValidQuantity ? 'danger' : 'success';
    }
    get showVolumeDiscounts() {
        return this.product != null
            && this.product.unit != null
            && !this.product.unit.is_restricted_volumes
            && this.discounts.length > 1;
    }
    get showPackSizes() {
        return this.product != null
            && this.product.unit != null
            && this.product.unit.is_restricted_volumes;
    }
    update() {
        if (!this.isValidQuantity) {
            return;
        }
        this.getPrice();
        this.checkStock();
    }
    getPrice() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.loadingPrice = true;
            this.pricing = yield getUnitPrice(this.product.sku, this.packSize, this.quantity);
            this.loadingPrice = false;
        });
    }
    checkStock() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.loadingStock = true;
            this.isInStock = yield checkUnitStock(this.product.sku, this.packSize, this.quantity);
            this.loadingStock = false;
        });
    }
    getDiscounts() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product) {
                return;
            }
            this.loadingDiscounts = true;
            this.discounts = yield getProductDiscounts(this.product.id, this.pricing.ex_vat_base_unit_price);
            this.loadingDiscounts = false;
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.product || !this.product.sku) {
                return;
            }
            this.isAddingToCart = true;
            try {
                addToCart({
                    sku: this.product.sku,
                    qty: this.quantity,
                    attributes: this.packSize ? {
                        "Pack Size": this.packSize.toString()
                    } : {}
                }, false);
            }
            catch (e) {
                console.error(e);
            }
            this.isAddingToCart = false;
        });
    }
    mounted() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let slug = window.location.href.split('/').pop();
            let { data } = yield axios
                .get('/api/accessories/productBySlug', { params: { slug } });
            this.product = data;
            if ((_a = this.product.unit) === null || _a === void 0 ? void 0 : _a.is_restricted_volumes) {
                // Get the pack size options
                let { data } = yield axios
                    .get('/api/accessories/packSizes', { params: { productID: this.product.id } });
                // Set the smallest discount option
                this.packSize = data[0].quantity;
                this.packSizeOptions = data.map(packSize => ({
                    value: packSize.quantity,
                    text: `x${packSize.quantity} ${packSize.discount < 0 ? `(Save ${packSize.discount * -1}%)` : ``}`
                }));
                // Get the price with the smallest discount option
                yield this.getPrice();
            }
            else {
                // Get the price for one
                yield this.getPrice();
                // Get the regular volume discounts
                yield this.getDiscounts();
            }
            yield this.checkStock();
            this.loading = false;
        });
    }
    created() {
        this.vatMode = getVatMode();
        isAdmin()
            .then(isAdmin => this.isAdmin = isAdmin);
    }
};
__decorate([
    Watch('packSize'),
    Watch('quantity')
], Unit.prototype, "debouncedUpdate", void 0);
Unit = __decorate([
    Component({
        components: {
            BOverlay, BRow, BCol, BFormGroup, BFormRadioGroup, BFormInput, BButton, BCard, BAlert,
            DiscountsBreakdown,
            UpsellUnitProduct, ProductDiscontinued
        }
    })
], Unit);
export default Unit;
